import { supabase } from "../lib/supabase";

export const ARTIST_NAME_MAX_LENGTH = 20;

/**
 * Counts the number of code points in a string.
 * Matches the Postgres char_length() behavior used by the DB constraint.
 */
export function countArtistNameLength(value) {
  const str = String(value || "");
  let count = 0;
  for (const _char of str) {
    count += 1;
  }
  return count;
}

export function isArtistNameValid(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return false;
  const length = countArtistNameLength(trimmed);
  return length >= 1 && length <= ARTIST_NAME_MAX_LENGTH;
}

export function normalizeArtistName(value) {
  return String(value || "").trim();
}

export async function fetchArtistName(userId) {
  if (!userId) return null;
  try {
    const { data, error } = await supabase
      .from("profiles")
      .select("artist_name")
      .eq("id", userId)
      .maybeSingle();
    if (error) {
      // eslint-disable-next-line no-console
      console.warn("[ARTIST_NAME] fetch failed", error?.message || error);
      return null;
    }
    const value = data?.artist_name || null;
    return value ? String(value).trim() : null;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[ARTIST_NAME] fetch threw", err?.message || err);
    return null;
  }
}

export async function saveArtistName(userId, rawValue) {
  if (!userId) {
    return { ok: false, error: "missing_user_id" };
  }
  const value = normalizeArtistName(rawValue);
  if (!isArtistNameValid(value)) {
    return { ok: false, error: "invalid_value" };
  }
  try {
    const { error } = await supabase
      .from("profiles")
      .update({ artist_name: value })
      .eq("id", userId);
    if (error) {
      // Postgres unique_violation. Surface a stable error code so the UI can
      // show a user-friendly "name already taken" message in the active locale.
      if (
        error.code === "23505"
        || /duplicate key|unique constraint/i.test(error.message || "")
      ) {
        return { ok: false, error: "name_taken" };
      }
      return { ok: false, error: error.message || "update_failed" };
    }
    return { ok: true, value };
  } catch (err) {
    return { ok: false, error: err?.message || "update_threw" };
  }
}
